import type {RouteRecordRaw} from 'vue-router';
import {propositionGuard} from '@/router/guards/propositionGuard';

export const tellAFriendRoutes: RouteRecordRaw[] = [
  {
    path: '/tell-a-friend',
    meta: {
      permissions: ['selectAffiliate'],
    },
    beforeEnter(to, from) {
      propositionGuard(to, from, (proposition) => proposition.enableTellAFriend);
    },
    children: [
      {
        path: '',
        name: 'tellafriend',
        component: () => import('@/views/TellAFriend/TellAFriend.vue'),
        meta: {
          permissions: ['selectAffiliate'],
          title: (t) => t('tellAFriend.title'),
        },
      },
      {
        name: 'tellafriend-invite',
        path: 'invite',
        component: () => import('@/views/TellAFriend/TellAFriendInvite.vue'),
        meta: {
          permissions: ['selectAffiliate'],
          title: (t) => t('tellAFriend.title'),
        },
      },
    ],
  },
];
